export default __webpack_public_path__ + "static/media/Luna.cf27da2e.jpg";